import { useOrganization } from "@/context/organization.context";
import { useMemo } from "react";

export default function useSettings() {
  const { activeOrg, refetch } = useOrganization();

  const settings: any = useMemo(() => {
    return activeOrg?.settings;
  }, [activeOrg]);

  return {
    settings: settings,
    refetch,
  };
}
